import config from "../../../../config.json";

export default class DocumentHelper {

    static getUrl(document) {
        const {path, basename, extension} = document;

        return `${config.url_documents}${path}${basename}/${basename}.${extension}`;
    }
}
